module.exports = __webpack_public_path__ + "img/山西省地质灾害监测预警系统.2e310805.jpg";